import store from '@/store';
import {
  BillingSubscriptionStatusEnum,
  Company,
  CompanyStatusEnum,
} from '../../../api/v1';

export const isActiveCompany = (company: Company): boolean =>
  CompanyStatusEnum.Active === company.status &&
  (!store.state.billing.currentSubscription ||
    store.state.billing.currentSubscription.status ===
      BillingSubscriptionStatusEnum.Active);
